module.exports = __webpack_public_path__ + "media/fonts/SovremennicWide-Bold-a8119eb06e37b058816ec3e30d728437.woff2";